import React from 'react';
import './PageContainer.css';

interface PageContainerProps {
  children: React.ReactNode;
  maxWidth?: number;
  padding?: string;
}

const PageContainer: React.FC<PageContainerProps> = ({
  children,
  maxWidth = 800,
  padding = '24px'
}) => {
  return (
    <div className="page-container-wrapper" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflowY: 'auto',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        maxWidth,
        margin: '0 auto',
        padding,
        minHeight: '100vh',
        backgroundColor: 'transparent'
      }}>
        {children}
      </div>
    </div>
  );
};

export default PageContainer;
